import React from 'react';
import { ControlGroup } from './ControlGroup';

interface SmartInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (val: number) => void;
  darkMode: boolean;
  tooltip?: string;
  settingKey?: string;
  disabled?: boolean;
  disabledMessage?: string;
  modes?: string[];
  fullWidth?: boolean;
}

export const SmartInput: React.FC<SmartInputProps> = ({ 
  label, value, min, max, step = 1, onChange, darkMode, tooltip, settingKey, disabled, disabledMessage, modes, fullWidth 
}) => (
  <ControlGroup 
    label={label} 
    tooltip={tooltip} 
    settingKey={settingKey}
    disabled={disabled} 
    disabledMessage={disabledMessage} 
    modes={modes}
    darkMode={darkMode}
  >
    <div className="flex gap-3 items-center w-full min-w-0">
      <input 
        type="range" 
        min={min} 
        max={max} 
        step={step} 
        value={value} 
        onChange={e => onChange(parseFloat(e.target.value))} 
        className="flex-1 accent-accent-primary min-w-[60px] shadow-inner"
      />
      <input 
        type="number" 
        min={min}
        max={max}
        step={step}
        value={value} 
        onChange={e => {
          const val = parseFloat(e.target.value);
          if (!isNaN(val)) onChange(val);
        }}
        className={`w-20 px-2 py-1.5 text-[11px] font-mono font-bold text-center border rounded-xl outline-none transition-all flex-shrink-0 ${
          darkMode 
          ? 'bg-black/60 border-white/10 text-white focus:border-white/30 focus:shadow-[0_0_15px_rgba(255,255,255,0.05)]' 
          : 'bg-white border-neutral-200 text-neutral-800 focus:border-neutral-400 focus:shadow-sm'
        }`}
      />
    </div>
  </ControlGroup>
);